/**
 * 1.67 (193) — the kitchen screen: a locked station device (kitchen, bar, or both). The station names are 1.66's
 * (`tables.station.*`).
 */
export const kitchen = {
  'kitchen.both': 'სამზარეულო და ბარი',
  'kitchen.open': 'სამზარეულოს ეკრანი',
  'kitchen.setup.title': 'სამზარეულოს ეკრანი',
  'kitchen.setup.sub': 'აირჩიე, რომელი შეკვეთები გამოჩნდეს ამ მოწყობილობაზე. ეკრანი ჩაიკეტება — გამოსვლას სისტემის PIN სჭირდება.',
  'kitchen.setup.lock': 'ჩაკეტვა და დაწყება',
  'kitchen.setup.back': 'უკან',
  'kitchen.setup.noBranch': 'ჯერ აირჩიე ფილიალი — სამზარეულოს ეკრანი ერთი ფილიალის შეკვეთებს აჩვენებს',
  'kitchen.pin.title': 'სისტემის PIN',
  'kitchen.pin.wrong': 'PIN არასწორია',
  'kitchen.pin.ok': 'დადასტურება',
  'kitchen.start': 'დაწყება',
  'kitchen.startHint': 'შეეხე — ჩაირთვება ხმა და ეკრანი აღარ ჩაქრება',
  'kitchen.orders': '{n} შეკვეთა',
  'kitchen.late': '{n} გვიანდება',
  'kitchen.exit': 'გამოსვლა',
  'kitchen.new': 'ახალი',
  'kitchen.batch': 'გაგზავნა {n}',
  'kitchen.ready': 'მზადაა',
  'kitchen.allReady': 'ყველა მზადაა',
  'kitchen.paid': 'გადახდილია',
  'kitchen.cancelled': 'გაუქმდა',
  'kitchen.cancelledWhy': 'გაუქმდა: {reason}',
  'kitchen.recent': 'ახლახან',
  'kitchen.undo': 'დაბრუნება',
  'kitchen.empty': 'შეკვეთა არ არის — ახალი აქ გამოჩნდება',
} as const
